import initCookieBanner from "./components/cookie-banner";
import initCookiePreferencesPage from "./components/cookie-preferences-page";

initCookieBanner();
initCookiePreferencesPage();